"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var pairing = __importStar(require("./constants/pairing"));
var remoting = __importStar(require("./constants/remoting"));
var app = __importStar(require("./constants/app"));
exports.remotingWhitelist = [
    pairing.actions.CREATE_DISPLAY_DEVICE_SUCCESS,
    pairing.actions.DISPLAY_PAIRED,
    pairing.actions.DISPLAY_UNPAIRED,
    pairing.actions.GET_DISPLAY_DEVICE_INFO_SUCCESS,
    pairing.actions.REMOTE_UNLINK_SUCCESS,
    pairing.actions.RESET_PAIRING_STATE,
    pairing.actions.GET_DEVICE_LOGIN_SUCCESS,
    remoting.actions.GRAPHITE_EVENT_RECEIVED,
    app.actions.changeVolumeInCall
];
exports.remotingWhitelistFilter = [
    ['app', 'remoting', 'pairing', 'uuid'],
    ['app', 'remoting', 'pairing', 'pairingCode'],
    ['app', 'remoting', 'pairing', 'displayCipher'],
    ['app', 'remoting', 'pairing', 'displayPlatform'],
    ['app', 'remoting', 'pairing', 'pairedUuid'],
    ['app', 'remoting', 'display', 'volume']
];
